import { useQuery } from '@tanstack/react-query'
import { Card, CardBody, CardHeader, EmptyState } from '@akillidernek/ui'
import { KeyRound } from 'lucide-react'
import { api } from '../api'
import { AyarlarSekmeleri } from './ayarlar-sekmeler'
import { useTenantSlug } from '../use-tenant'

/** Sağlayıcı anahtarları (YES-75) — yalnızca maskeli değerler gösterilir. */
export function Ayarlar() {
  const slug = useTenantSlug()
  const { data } = useQuery({
    queryKey: ['providers', slug],
    enabled: Boolean(slug),
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/providers')
      return data ?? []
    },
  })

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-lg font-semibold">Ayarlar</h1>
      <AyarlarSekmeleri />
      <Card>
        <CardHeader
          title="Sağlayıcı anahtarları"
          description="Şifreli saklanır; yalnızca son dört karakter gösterilir."
        />
        <CardBody>
          {data && data.length > 0 ? (
            <ul className="flex flex-col gap-2">
              {data.map((credential) => (
                <li
                  key={credential.id}
                  className="flex items-center justify-between rounded-[var(--radius-control)] border border-[var(--ad-border)] px-3 py-2"
                >
                  <span className="text-sm font-medium">{credential.provider_key}</span>
                  <span className="font-mono text-xs text-[var(--ad-text-muted)]">
                    {Object.entries(credential.masked_secrets)
                      .map(([name, value]) => `${name}: ${value}`)
                      .join(' · ')}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState
              icon={<KeyRound className="size-8" />}
              title="Henüz sağlayıcı anahtarı yok"
              description="Ödeme ve SMS sağlayıcılarınızın anahtarlarını buradan girersiniz; bir kez girildikten sonra geri okunamaz."
            />
          )}
        </CardBody>
      </Card>
    </div>
  )
}
